module.exports = __webpack_public_path__ + "assets/star-outline.515d1ecc.svg";